import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
export const emailPreviewUrl = (emailId, previewKey, __usedInTestsOnlyToForceHublet) => {
  const subdomain = enviro.isProd() ? 'preview' : 'previewqa';
  const domain = enviro.ifHublet({
    isNa1: () => 'hs-sites',
    isNonNa1: hublet => `hs-sites-${hublet}`
  }, __usedInTestsOnlyToForceHublet);
  const portalId = PortalIdParser.get();
  return `https://${subdomain}.${domain}.com/_hcms/preview/content/${emailId}?portalId=${portalId}&preview_key=${previewKey}&hsLoginVerifyDisabled=true`;
};
export const emailUrl = emailId => {
  const portalId = PortalIdParser.get();
  return `/email/${portalId}/details/${emailId}`;
};